import React from "react";
import styles from "./DocumentHeader.module.css";
import ZoomHandler from "./zoom-handler/ZoomHandler";
import PageHandler from "./page-handler/PageHandler";
import { CustomButtonLink, icon } from "../../../../../../common/components";
import { isSegFeatureEnabled, SegFlags, translate } from "../../../../../../common/providers";

const DocumentHeader = ({
	docId,
	isFile,
	numberOfPages,
	page,
	pageDimensions,
	pdfContainerWidth,
	previousPath,
	redirectUrl,
	status,
	zoom,
	onChangePage,
	onZoomChange,
}) => (
	<div className={styles.container}>
		<div className={styles.container__leftSide}>
			{isFile && isSegFeatureEnabled(SegFlags.SMART_REVIEW) && (
				<CustomButtonLink
					openInNewTab
					color="primary"
					startIcon={icon.faUpRightFromSquare}
					state={{ previous: previousPath }}
					to={redirectUrl}
					variant="contained"
				>
					{translate(
						status === "COMPLETED"
							? "document-center.side-panel.open-document"
							: "document-center.side-panel.access-path"
					)}
				</CustomButtonLink>
			)}
		</div>
		<div className={styles.container__rightSide}>
			<ZoomHandler
				documentId={docId}
				pageDimensions={pageDimensions}
				pdfContainerWidth={pdfContainerWidth}
				zoom={zoom}
				onZoomChange={onZoomChange}
			/>
			<PageHandler documentId={docId} numberOfPages={numberOfPages} page={page} onChangePage={onChangePage} />
		</div>
	</div>
);
export default DocumentHeader;
